import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalBonitet = ({
  visible,
  onHide,
  onConfirm,
  onReject,          // <- NOVO (akcija na "Ne")
  message,
  data               // <- NOVO (bonitet data)
}) => {
  const bonitet = data?.Bonitetna_ocena?.[0]; // 1. stavka niza (ako postoji)

  const footer = (
    <div>
      <Button
        label="Da"
        icon="pi pi-check"
        onClick={onConfirm}
        className="p-button-success"
        autoFocus
      />
      <Button
        label="Ne"
        icon="pi pi-times"
        onClick={onReject}   // <- umesto onHide
        className="p-button-secondary"
      />
    </div>
  );

  const formatDateSR = (isoString) => {
  if (!isoString) return '';

  const d = new Date(isoString);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

  return (
    <Dialog
      header="Potvrda"
      visible={visible}
      style={{ width: '520px' }}
      footer={footer}
      onHide={onHide}
      modal
      className="confirmation-modal"
    >
      <div style={{ padding: '0.5rem 0.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
          <i className="pi pi-info-circle" style={{ fontSize: '2rem', color: 'black' }} />
          <span>{message}</span>
        </div>

        {/* Glavne info */}
        <div style={{ lineHeight: 1.6 }}>
          <div><b>Naziv:</b> {data?.Naziv_skraceni ?? '-'}</div>
          <div><b>MBR:</b> {data?.MBR ?? '-'}</div>
          <div><b>PIB:</b> {data?.PIB ?? '-'}</div>
          <div><b>Delatnost:</b> {data?.Delatnost_Naziv ?? '-'}</div>
          <div><b>Broj zaposlenih:</b> {data?.Poslovanje?.[0].BrojZaposlenih ?? '-'}</div>

          <div><b>ROE (povraćaj na kapital):</b> {formatNumber(data?.Poslovanje?.[0].Roe)}</div>
          <div><b>ROA (povraćaj na imovinu):</b> {formatNumber(data?.Poslovanje?.[0].Roa)}</div>

          <div><b>Prosečno vreme naplate potraživanja (dani):</b> {formatNumber(data?.Poslovanje?.[0].Prosecno_vreme_naplate_potrazivanja)}</div>
          <div><b>Prosečno vreme plaćanja dobavljačima (dani):</b> {formatNumber(data?.Poslovanje?.[0].Prosecno_vreme_placanja_dobavljacima)}</div>

          <div><b>Gotovina:</b> {formatNumber(data?.Poslovanje?.[0].Gotovina)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Potraživanja od kupaca:</b> {formatNumber(data?.Poslovanje?.[0].Potrazivanja_od_kupaca)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Obaveze prema dobavljačima:</b> {formatNumber(data?.Poslovanje?.[0].Obaveze_prema_dobavljacima)} {data?.Poslovanje?.[0].Valuta}</div>

          <div><b>Ukupna aktiva:</b> {formatNumber(data?.Poslovanje?.[0].Ukupna_aktiva)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Stalna imovina:</b> {formatNumber(data?.Poslovanje?.[0].Stalna_imovina)} {data?.Poslovanje?.[0].Valuta}</div>

          <div><b>Poslovni prihod po zaposlenom:</b> {formatNumber(data?.Poslovanje?.[0].Poslovni_prihod_po_zaposlenom)} {data?.Poslovanje?.[0].Valuta}</div>

          <div><b>Neto gubitak:</b> {formatNumber(data?.Poslovanje?.[0].Neto_gubitak)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Neto dobitak:</b> {formatNumber(data?.Poslovanje?.[0].Neto_dobitak)} {data?.Poslovanje?.[0].Valuta}</div>

          <div><b>Poslovni prihodi:</b> {formatNumber(data?.Poslovanje?.[0].Poslovni_prihodi)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Ukupni prihodi:</b> {formatNumber(data?.Poslovanje?.[0].Ukupni_prihodi)} {data?.Poslovanje?.[0].Valuta}</div>

          <div><b>Dugoročne obaveze i rezervisanja:</b> {formatNumber(data?.Poslovanje?.[0].Dugorocne_obaveze_i_rezervisanja)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Kapital:</b> {formatNumber(data?.Poslovanje?.[0].Kapital)} {data?.Poslovanje?.[0].Valuta}</div>
          <div><b>Datum osnivanja:</b> {formatDateSR(data?.Datum_Osnivanja) ?? '-'}</div>
          
        </div>

        {/* Bonitetna ocena */}
        <div style={{ marginTop: '1rem', padding: '0.75rem', border: '1px solid #e5e5e5', borderRadius: '8px' }}>
          <div style={{ marginBottom: '0.5rem' }}>
            Bonitetna ocena:{' '}
            <span style={{ fontWeight: 800, fontSize: '1.2rem' }}>
              {bonitet?.Bonitetna_Ocena ?? 'N/A'}
            </span>
          </div>

          <div style={{ fontSize: '0.95rem', opacity: 0.9 }}>
            <div><b>Dinamična ocena:</b> {bonitet?.Dinamicna_Ocena ?? '-'}</div>
            <div><b>Godina bilansa:</b> {bonitet?.Godina_Bilans ?? '-'}</div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModalBonitet;